// COPY APF Partners — copy definitiva rev. 2 (02-copy-sito.md, "Fatturiamo"), usata verbatim.
// Le parti tra parentesi quadre sono segnaposto da sostituire prima del lancio.

export const COPY = {
    brand: "APF Partners",

    nav: [
        { label: "Come si comincia", id: "cominciare" },
        { label: "Metodo", id: "metodo" },
        { label: "Il patto", id: "patto" },
        { label: "Quaderni", id: "quaderni", to: "/quaderni" },
    ],
    cta: "Analisi gratuita",

    hero: {
        cols: [
            {
                letter: "A",
                verb: "Ascoltiamo",
                text: "Prima di toccare qualsiasi cosa capiamo come entrano i clienti oggi, dove si perdono, e cosa ti frena. Dentro, nei processi. Fuori, nel mercato.",
            },
            {
                letter: "P",
                verb: "Progettiamo",
                text: "Un meccanismo, non una campagna: da dove arriva il cliente a come diventa fatturato. Con priorità, numeri e una lista di cose da fare, in ordine.",
            },
            {
                letter: "F",
                verb: "Fatturiamo",
                text: "Noi, insieme. Il lavoro non è finito quando è consegnato: è finito quando porta clienti. Store, landing, campagne, contenuti, software: tutto serve a questo, e lo facciamo noi.",
            },
        ],
    },

    apertura: {
        caption: "APF Partners — partner riservati per aziende che vendono",
        headlineA: "Firmiamo la tua crescita,",
        headlineB: "non lo store.",
        sub: "Costruiamo il meccanismo che porta i clienti — e-commerce o lead generation, B2B o B2C — e restiamo dentro finché fattura. Poche aziende, seguite davvero.",
        proof: "I trend li conosciamo. Non è quello per cui ci pagano.",
    },

    marquee: [
        "Non firmiamo",
        "Non mostriamo",
        "Non rivendiamo",
        "Entriamo",
        "Restiamo",
        "Fatturiamo",
    ],

    metodo: {
        caption: "Il metodo",
        titleA: "Ascoltiamo, progettiamo,",
        titleB: "fatturiamo.",
        lead: "Le tre lettere sono il modo in cui lavoriamo. Non si spiegano con le schede: si vedono nella struttura di ogni progetto e di ogni proposta.",
    },

    servizi: {
        caption: "Di cosa ci occupiamo",
        titleA: "Acquisizione fuori,",
        titleB: "gestione dentro.",
        lead: "Non vendiamo servizi. Costruiamo pezzi di un meccanismo. Aprine uno.",
        items: [
            {
                title: "Acquisizione",
                image: { src: "/foto/laptop-contenuti.webp", alt: "Le creatività delle campagne, sullo schermo" },
                text: "Il meccanismo intero: da dove arriva il cliente, cosa vede, cosa fa, cosa succede dopo. Per un e-commerce è traffico, store e riacquisto. Per chi vende con preventivi e appuntamenti è lead, qualifica e chiusura. Lo progettiamo con i numeri e lo teniamo noi, finché non gira da solo.",
            },
            {
                title: "Store",
                image: { src: "/foto/store-scheda.webp", alt: "Una scheda prodotto costruita per vendere" },
                text: "Lo store è un negozio, non un sito. Lo costruiamo su Shopify perché è quello che funziona in Italia, e lo teniamo noi: catalogo, schede, pagamenti, spedizioni, resi, riacquisto. Se qualcosa si rompe alle sette di sera lo sappiamo prima di te.",
            },
            {
                title: "Lead",
                image: { src: "/foto/landing-vigilanza.webp", alt: "Landing con form e scelta dell'orario: ti richiamiamo in dieci minuti" },
                text: "Per chi non vende dal carrello: landing, form, campagne, sequenze di follow-up e un agente che risponde entro dieci minuti a chi lascia il numero. Il lead non è il risultato: è l'inizio. Il risultato è l'appuntamento fatto.",
            },
            {
                title: "Contenuti",
                image: { src: "/foto/set-bottega.webp", alt: "Il set fotografico: il prodotto in mano, la luce giusta" },
                text: "Foto, video, testi, email. Li produciamo noi, nella tua azienda, con la tua gente e il tuo prodotto in mano. Servono al meccanismo, non a riempire un calendario: ogni contenuto ha un motivo per esistere e un posto dove andare.",
            },
            {
                title: "Gestione",
                image: { src: "/foto/caseificio.webp", alt: "Il caseificio dove nasce il report del mattino" },
                text: "La parte che non si vede. Report degli ordini, produzione, magazzino, spedizioni, CRM, fatture: software su misura e automazioni che tolgono il lavoro ripetitivo all'ufficio e non fanno perdere per strada un cliente che ha già detto sì.",
            },
        ],
    },

    patto: {
        caption: "Il patto",
        titleA: "Tre no,",
        titleB: "tre sì.",
        cells: [
            {
                neg: "Non firmiamo.",
                negText:
                    'Nessun "realizzato da" nel footer. Lo store è tuo, il brand è tuo, il merito è tuo.',
                pos: "Entriamo.",
                posText:
                    "Non consegniamo un lavoro e spariamo. Prendiamo un pezzo di responsabilità dentro l'azienda e ci sentiamo ogni settimana.",
            },
            {
                neg: "Non mostriamo.",
                negText:
                    "Nessun logo in home, nessun caso studio con il tuo nome. Quello che facciamo per te resta tra noi.",
                pos: "Restiamo.",
                posText:
                    "Per anni, non per campagne. Poche aziende, seguite davvero — e se non c'è posto lo diciamo.",
            },
            {
                neg: "Non rivendiamo.",
                negText:
                    "I tuoi dati, i tuoi numeri, i tuoi fornitori non diventano mai argomenti di vendita con qualcun altro.",
                pos: "Fatturiamo.",
                posText:
                    "Rispondiamo del risultato, con numeri veri e precisi, anche quando sono piccoli. Soprattutto quando sono piccoli.",
            },
        ],
    },

    bottega: {
        caption: "L'unico store che firmiamo",
        name: "Bottega Paesano",
        did: ["Store Shopify", "App", "Contenuti", "Campagne", "Email", "Riacquisto"],
        text: "Il brand di cosmetica che abbiamo costruito da partner strategici: store, app, contenuti, campagne, email, riacquisto. È l'unico lavoro che possiamo raccontare per intero, ed è quello dove rischiamo anche noi.",
        images: {
            desktop: "/bottega/home-desktop.jpg",
            mobile: "/bottega/home-mobile.jpg",
        },
        number: "+43% ordini ricorrenti",
        backstage: {
            caption: "Dietro le quinte",
            src: "/foto/set-bottega.webp",
            alt: "Il set fotografico per la crema barba Bottega Paesano",
            text: "Le foto dei prodotti le facciamo noi, sul nostro set. Nessuna agenzia in mezzo: il prodotto in mano, la luce giusta, il tempo che serve.",
        },
        app: {
            caption: "L'app",
            text: "Un'app per chi entra in salone e per chi compra online: carta fedeltà nel Wallet con il −5% sempre, shop con lo sconto già applicato, prenotazione del taglio in tre tocchi.",
            screens: [
                { src: "/bottega/app-3.jpg", label: "Carta fedeltà nel Wallet" },
                { src: "/bottega/app-2.jpg", label: "Shop con la Carta attiva" },
                { src: "/bottega/app-1.jpg", label: "Prenotazione in salone" },
            ],
        },
        link: { label: "Vai allo store", href: "https://www.bottegapaesano.it" },
        note: "Dichiarato come eccezione al patto.",
    },

    casi: {
        caption: "Casi senza nome",
        titleA: "Senza nome,",
        titleB: "con i numeri.",
        lead: "Settore, il problema, cosa abbiamo costruito, un numero. I nomi restano dove devono restare.",
        items: [
            {
                meta: "E-commerce — un caseificio in Campania",
                title: "Il report che arriva da solo",
                text: "Ogni mattina il caseificio perdeva tempo a ricostruire gli ordini del giorno. Abbiamo costruito un'app che alle 7 manda il report pronto: buste, chili, cosa produrre.",
                result: "Da 40 minuti al giorno a zero.",
                photo: { src: "/foto/app-caseificio.webp", alt: "Il report del mattino sul telefono, in caseificio", label: "Il report del mattino, in mano" },
            },
            {
                meta: "E-commerce — un integratore per uomo",
                title: "Una pagina che vende da sola",
                text: "Un buon prodotto senza una storia. Abbiamo scritto e costruito la pagina, girato i contenuti e impostato le campagne.",
                result: "ROAS 8,6× (media su tre mesi), conversion rate 2,9%.",
                metrics: {
                    source: "Shopify e Meta, 17 giugno – 17 settembre 2026",
                    rows: [
                        { v: "1.434", l: "ordini", d: "+266%" },
                        { v: "90,6K €", l: "vendite", d: "+107%" },
                        { v: "2,9%", l: "tasso di conversione", d: "+50%" },
                        { v: "8,36", l: "ROAS, valore acquisto", d: "63.110 €" },
                    ],
                    shots: [
                        { strip: "/casi/shopify-90-giorni-strip.png", full: "/casi/shopify-90-giorni.png", alt: "Shopify: sessioni, vendite, ordini e tasso di conversione degli ultimi 90 giorni" },
                        { strip: "/casi/meta-roas-strip.png", full: "/casi/meta-roas.png", alt: "Meta Ads: ROAS 8,36, valore risultati 63.110 €, CTR unico 4,3%, 2.120 aggiunte al carrello" },
                    ],
                },
            },
            {
                meta: "Lead generation — un istituto di vigilanza privata",
                title: "Le richieste giuste, in dieci minuti",
                text: "Un servizio nuovo per ville e appartamenti privati, e nessuna richiesta online. Abbiamo costruito brand, landing e campagne, e il follow-up che richiama chi lascia il numero entro dieci minuti.",
                result: "Costo per richiesta 1,68 €, con un ticket medio di 700 €.",
                metrics: {
                    source: "Meta Ads, una campagna contatti",
                    rows: [
                        { v: "510", l: "contatti dal modulo" },
                        { v: "1,25 €", l: "per contatto" },
                        { v: "637,7 €", l: "spesa totale" },
                        { v: "3,21 €", l: "CPM", d: "198.650 impression" },
                    ],
                    shots: [
                        { strip: "/casi/meta-contatti-strip.png", full: "/casi/meta-contatti.png", alt: "Meta Ads: 510 contatti a 1,25 € ciascuno con 637,7 € di spesa" },
                    ],
                },
            },
        ],
    },

    quaderni: {
        caption: "Guide gratuite — i Quaderni",
        titleA: "Cose utili,",
        titleB: "senza vendere.",
        lead: "Quello che diciamo alle aziende con cui lavoriamo, scritto per tutti.",
        // sommari, date e tempi di lettura indicativi: da confermare con i testi definitivi
        items: [
            {
                title: "Cosa chiedere a chi ti fa lo store (prima di firmare)",
                summary:
                    "Dieci domande da fare prima di versare un acconto. Se una risposta è vaga, è già una risposta.",
                date: "Giugno 2026",
                read: "6 min di lettura",
            },
            {
                title: "Quanto costa davvero acquisire un cliente, voce per voce",
                summary:
                    "Traffico, store, follow-up, resi: i costi veri di un cliente nuovo, voce per voce.",
                date: "Maggio 2026",
                read: "8 min di lettura",
            },
            {
                title: "Perché i lead che paghi non ti rispondono (e cosa succede nei primi dieci minuti)",
                summary:
                    "Il lead si raffredda in dieci minuti. Cosa deve succedere in quel tempo, e chi lo fa.",
                date: "Aprile 2026",
                read: "5 min di lettura",
            },
        ],
        all: "Tutte le guide",
    },

    form: {
        caption: "Come si comincia",
        titleA: "La tua analisi,",
        titleB: "gratuita.",
        sub: "In 48 ore ricevi un'analisi scritta di come acquisisci clienti oggi e cosa cambieremmo per primo. Gratis, senza call.",
        mobileSub: "Un’analisi scritta entro 48 ore. Gratis, senza call.",
        modes: [
            { id: "store", label: "Vendo da uno store", urlLabel: "L'indirizzo del tuo store" },
            { id: "lead", label: "Vendo con preventivi o appuntamenti", urlLabel: "Il tuo sito", whatLabel: "In una riga, cosa vendi" },
            { id: "nosite", label: "Non ho ancora un sito", urlLabel: null, whatLabel: "In una riga, cosa vendi e a chi" },
        ],
        emailLabel: "La tua email",
        phoneLabel: "Il tuo numero (se preferisci che ti chiamiamo noi)",
        submit: "Ricevi l’analisi",
        note: "Nessuna newsletter. Nessuna chiamata a sorpresa.",
        confirmation:
            "Ricevuto. Entro 48 ore ti arriva l'analisi. Se ti chiamiamo, è perché c'è qualcosa da dire.",
        error: "Qualcosa non ha funzionato. Riprovate tra poco.",
        deliverTitle: "Cosa ricevi in 48 ore",
        // pitch advertorial a sinistra del form (test A/B: ?v=A|B|C)
        variants: [
            {
                id: "A",
                pitch: "Un'analisi scritta da chi i meccanismi di acquisizione li tiene in piedi ogni giorno: cosa funziona, dove perdi clienti o richieste, cosa faremmo noi per primo.",
                bullets: [
                    "Dove perdi il cliente: i tre punti del percorso dove chi entra esce, con il perché.",
                    "Cosa cambieremmo per primo: tre interventi in ordine, con quanto pesano.",
                    "Cosa non toccheremmo: le cose che funzionano e che qualcun altro ti direbbe di rifare.",
                ],
            },
            {
                id: "B",
                pitch: "Non un preventivo: un'analisi. Per iscritto, in 48 ore, senza call e senza impegno. La stessa che facciamo alle aziende che seguiamo, prima di entrare.",
                bullets: [
                    "Cosa vede un cliente nei primi dieci secondi, e perché se ne va.",
                    "Cosa costa troppo, cosa manca, cosa è di troppo.",
                    "Un piano in tre mosse, che puoi fare anche senza di noi.",
                ],
            },
            {
                id: "C",
                pitch: "Niente demo, niente commerciali. Ricevi per email un documento chiaro: numeri, problemi, priorità. Poi decidi tu.",
                bullets: [
                    "Un giudizio diretto su acquisizione, store o lead, e gestione.",
                    "I tre punti dove intervenire per primi.",
                    "Se possiamo aiutarti te lo diciamo. Se no, anche.",
                ],
            },
        ],
    },

    chiusura: {
        title: "La tua analisi, gratuita.",
        sub: "48 ore. Scritta a mano. Senza call.",
        closing: "Poche aziende, seguite davvero. Se non c'è posto lo diciamo.",
    },

    analisi: {
        caption: "APF Partners · partner riservati per aziende che vendono",
        title: "Non ti arrivano abbastanza clienti. Ti diciamo perché.",
        mobileTitle: "La tua analisi gratuita.",
        sub: "In 48 ore ricevi un'analisi scritta di come acquisisci clienti oggi — store o lead — e cosa cambieremmo per primo. Gratis, senza call.",
        receiveTitle: "Cosa c'è nell'analisi",
        receive: [
            "Dove perdi il cliente: i tre punti del percorso dove chi entra esce (o dove il lead si raffredda), con il perché.",
            "Cosa cambieremmo per primo: tre interventi in ordine, con quanto pesano.",
            "Cosa non toccheremmo: le cose che funzionano e che qualcun altro ti direbbe di rifare.",
        ],
        receiveNote: "Scritta a mano da chi la farebbe. Non un report automatico.",
        trustTitle: "Non vedrai i nostri clienti. È voluto.",
        trustText: "Non firmiamo gli store che facciamo, non mettiamo loghi in home e non usiamo i dati di un'azienda per venderne un'altra. Chi lavora con noi lo sa dal primo giorno: quello che facciamo per te resta tra noi. L'unico lavoro che raccontiamo per intero è il brand di cui siamo partner, perché è nostro.",
        trustNo: ["Non firmiamo.", "Non mostriamo.", "Non rivendiamo."],
        caseMeta: "Gestione — un caseificio in Campania",
        caseTitle: "Il report che arriva da solo.",
        caseText: "Ogni mattina il caseificio perdeva tempo a ricostruire gli ordini del giorno. Abbiamo costruito un'app che alle 7 manda il report pronto: buste, chili, cosa produrre.",
        caseResult: "Da 40 minuti al giorno a zero.",
        bottegaText: "Il brand di cosmetica che abbiamo costruito da partner strategici. È l'unico lavoro che possiamo raccontare per intero, ed è quello dove rischiamo anche noi.",
        faqTitle: "Domande che fanno tutti",
        faq: [
            { q: "È davvero gratis?", a: "Sì. L'analisi è il modo in cui capiamo se possiamo esserti utili. Se no, te lo diciamo e finisce lì." },
            { q: "Devo fare una call?", a: "No. Ricevi l'analisi via email. Se vuoi parlarne, ci scrivi tu." },
            { q: "Con quali aziende lavorate?", a: "Aziende che vendono e vogliono più clienti: e-commerce di prodotti fisici, e attività B2B o B2C che vendono con preventivi e appuntamenti." },
            { q: "Cosa succede dopo?", a: "Se l'analisi ti convince, ci sentiamo. Lavoriamo da partner, con un canone mensile, e seguiamo poche aziende alla volta." },
        ],
    },

    footer: {
        headlineA: "Firmiamo la tua crescita,",
        headlineB: "non lo store.",
        vat: "APF Partners S.r.l. — P.IVA / C.F. 11073611219",
        // social: aggiungere qui quando saranno attivi, es. { label: "LinkedIn", href: "https://…" }
        links: [
            { label: "Privacy", href: "/privacy" },
        ],
    },

    privacy: {
        title: "Informativa sulla privacy",
        intro: "Informativa ai sensi degli articoli 13 e 14 del Regolamento (UE) 2016/679 (GDPR) per chi visita questo sito e per chi ci invia una richiesta tramite il modulo.",
        updated: "Ultimo aggiornamento: settembre 2026.",
        sections: [
            {
                h: "1. Titolare del trattamento",
                p: [
                    "APF Partners S.r.l., P.IVA e Codice Fiscale 11073611219. Per qualsiasi richiesta relativa ai tuoi dati puoi scrivere a info@apf.partners.",
                ],
            },
            {
                h: "2. Quali dati trattiamo",
                p: [
                    "Dati che ci dai tu, compilando il modulo: indirizzo dello store o del sito, una descrizione di cosa vendi, email, numero di telefono (facoltativo), nome e cognome (facoltativo), azienda (facoltativo), una nota su cosa ti frena (facoltativa) e gli eventuali allegati che scegli di inviarci (PDF o immagini). Sei tu a decidere cosa scrivere: ti chiediamo di non inserire negli allegati dati di terzi o categorie particolari di dati.",
                    "Dati di navigazione: i sistemi tecnici possono trattare informazioni necessarie al funzionamento e alla sicurezza. Solo dopo il tuo consenso e se configurati, Google Analytics 4, Google Ads, Meta Pixel e TikTok Pixel possono misurare visite, interazioni e campagne, anche per pubblicità personalizzata. I nostri eventi applicativi non contengono email, telefono o testo dei moduli.",
                    "Il browser conserva le preferenze cookie, il tema e, se accedi all’area riservata, il token di accesso. La variante del testo viene memorizzata solo con il consenso alle Statistiche. Categorie, strumenti, durate e revoca sono descritti nell’Informativa cookie (/cookie).",
                ],
            },
            {
                h: "3. Perché li trattiamo e su quale base",
                p: [
                    "Per rispondere alla tua richiesta di analisi e, se lo vorrai, per il rapporto che ne seguirà: base giuridica è l'esecuzione di misure precontrattuali adottate su tua richiesta (art. 6, par. 1, lett. b GDPR).",
                    "Per la sicurezza del sito e la prevenzione di abusi: base giuridica è il nostro legittimo interesse (art. 6, par. 1, lett. f GDPR). Per Statistiche e Marketing facoltativi la base giuridica è invece il tuo consenso (art. 6, par. 1, lett. a GDPR), revocabile da Preferenze cookie senza limitare l’uso del sito.",
                    "Non ti manderemo newsletter e non useremo i tuoi contatti per comunicazioni commerciali diverse dalla risposta alla tua richiesta, salvo che tu ce lo chieda espressamente.",
                ],
            },
            {
                h: "4. Per quanto tempo li conserviamo",
                p: [
                    "I dati della richiesta sono conservati per 24 mesi dall'ultimo contatto. Se la richiesta si trasforma in un rapporto di lavoro, restano per la durata del rapporto e per i termini previsti dalla legge per gli obblighi fiscali e contabili. Gli allegati sono cancellati insieme alla richiesta. Puoi chiederne la cancellazione anticipata in qualsiasi momento.",
                ],
            },
            {
                h: "5. Chi può vedere i tuoi dati",
                p: [
                    "I dati delle richieste sono trattati dalle persone di APF Partners incaricate di risponderti. Se acconsenti ai servizi facoltativi configurati, i dati di navigazione possono essere comunicati ai relativi fornitori, che li trattano secondo le proprie informative. I contatti dei moduli non vengono aggiunti agli eventi applicativi di tracciamento.",
                    "Per far funzionare il sito ci appoggiamo a fornitori tecnici che agiscono come responsabili del trattamento (art. 28 GDPR) sulla base di un contratto: hosting del sito e del database, archiviazione degli allegati, invio delle notifiche email. Alcuni di questi fornitori possono trattare i dati fuori dall'Unione Europea: in questi casi il trasferimento avviene con le garanzie previste dal Capo V del GDPR (decisioni di adeguatezza o clausole contrattuali standard).",
                ],
            },
            {
                h: "6. I tuoi diritti",
                p: [
                    "Puoi chiederci in qualsiasi momento l'accesso ai tuoi dati, la rettifica, la cancellazione, la limitazione del trattamento, la portabilità, e puoi opporti al trattamento basato sul legittimo interesse (artt. 15–22 GDPR). Basta scrivere a info@apf.partners: rispondiamo entro 30 giorni.",
                    "Se ritieni che il trattamento violi la normativa, hai il diritto di proporre reclamo al Garante per la protezione dei dati personali (www.garanteprivacy.it) o all'autorità del Paese in cui risiedi.",
                ],
            },
            {
                h: "7. Conferimento dei dati",
                p: [
                    "Indirizzo del sito (o descrizione di cosa vendi) ed email sono necessari per rispondere: senza, non possiamo fare l'analisi. Tutto il resto è facoltativo.",
                ],
            },
            {
                h: "8. Modifiche",
                p: [
                    "Questa informativa può essere aggiornata. La versione in vigore è sempre quella pubblicata su questa pagina, con la data in alto.",
                ],
            },
        ],
    },

    grazie: {
        caption: "Ricevuto",
        title: "Il tuo caso è arrivato.",
        sub: "Da qui partono le 48 ore. Ecco cosa succede adesso, in ordine.",
        steps: [
            { when: "Adesso", text: "La tua richiesta è sul tavolo di una persona, non di un software. La leggiamo, apriamo il tuo sito o il tuo store e cominciamo a prendere appunti." },
            { when: "Entro 48 ore", text: "Ti arriva l'analisi per iscritto, alla tua email: dove perdi il cliente, cosa cambieremmo per primo, cosa non toccheremmo. Tre parti, sempre le stesse." },
            { when: "Poi", text: "Se c'è qualcosa da dire, ti chiamiamo per fissare una call e parlarne con calma. Se non possiamo aiutarti, te lo scriviamo lo stesso. Nessuna newsletter, nessuna chiamata a sorpresa." },
        ],
        pdf: {
            title: "Intanto, un esempio.",
            text: "Così vedi com'è fatta quella che riceverai: azienda inventata, struttura vera.",
            cta: "Apri l'esempio di analisi (PDF)",
        },
        back: "Torna al sito",
        quaderni: "Nel frattempo, i Quaderni",
    },

    iscriviti: {
        title: "I prossimi, via email.",
        text: "Quando scriviamo un quaderno nuovo te lo mandiamo. Niente altro: né offerte, né promemoria.",
        emailLabel: "La tua email",
        cta: "Avvisami",
        done: "Fatto. Il prossimo quaderno arriva a te.",
        note: "Puoi cancellarti con una risposta all'email.",
        error: "Qualcosa non ha funzionato. Riprova tra poco.",
    },

    anteprima: {
        caption: "Com'è fatta",
        title: "Un esempio, da sfogliare.",
        note: "Azienda inventata, numeri verosimili. La struttura è quella vera.",
        prev: "Indietro",
        next: "Avanti",
        pageLabel: (i, n) => `Pagina ${i} di ${n}`,
        download: {
            title: "Vuoi tenerlo?",
            text: "Lascia la tua email: scarichi l'esempio completo in PDF e, se vuoi, ti scriviamo noi per fare la tua.",
            emailLabel: "La tua email",
            cta: "Scarica il PDF",
            sending: "Un attimo…",
            done: "Il PDF si sta aprendo. Se vuoi la tua analisi, ti scriviamo noi.",
            open: "Apri il PDF",
            error: "Qualcosa non ha funzionato. Riprovate tra poco.",
        },
        pages: [
            {
                kicker: "Analisi — esempio",
                title: "Un pastificio artigianale, e-commerce Shopify.",
                body: [
                    "620 ordini al mese, ticket medio 38 €, il 71% del fatturato da campagne Meta. Nessuna email dopo l'acquisto. Riacquisto a 90 giorni: 9%.",
                    "Quello che segue è quello che scriveremmo noi. In tre parti, sempre le stesse.",
                ],
            },
            {
                kicker: "01 — Dove perdi il cliente",
                title: "Tre punti, con il perché.",
                items: [
                    "Pagina prodotto: 2,1% di aggiunte al carrello contro il 4–5% del settore. Le foto sono belle, ma manca il formato: quanti pacchi, quante porzioni, quanto dura.",
                    "Spedizione: la soglia per la gratuita (49 €) è sopra il ticket medio. Il 38% abbandona al checkout proprio lì.",
                    "Dopo l'acquisto: nessun contatto per 90 giorni. Chi ha già comprato è il cliente che ti costa meno, e oggi non lo stai chiamando.",
                ],
            },
            {
                kicker: "02 — Cosa cambieremmo per primo",
                title: "In ordine, con quanto pesa.",
                items: [
                    "Il flusso post-acquisto: tre email in 30 giorni (come si cucina, cosa abbinare, il riordino). Stima: riacquisto dal 9% al 15–18%. È l'intervento più leggero e il più veloce.",
                    "Soglia spedizione a 39 € e un formato 'dispensa' da 3 pacchi. Stima: +12% di ticket medio, meno abbandoni al checkout.",
                    "Le campagne: il 71% del fatturato dipende da un solo canale. Non lo spegneremmo: lo affiancheremmo con il riacquisto, per pagare meno ogni cliente nuovo.",
                ],
            },
            {
                kicker: "03 — Cosa non toccheremmo",
                title: "Le cose che funzionano.",
                items: [
                    "Il brand e la fotografia: sono il motivo per cui la gente clicca. Chi propone un restyling sta vendendo il suo lavoro, non il tuo risultato.",
                    "Lo store Shopify: non serve una piattaforma nuova. Serve fare meglio con quella che c'è.",
                    "Il prezzo: è giusto per il posizionamento. Il problema non è quanto costa, è quante volte si compra.",
                ],
                closing: "Se possiamo aiutarti te lo diciamo. Se no, anche.",
            },
        ],
    },

    quaderniPage: {
        caption: "Guide gratuite — i Quaderni",
        titleA: "Cose utili,",
        titleB: "senza vendere.",
        lead: "Quello che diciamo alle aziende con cui lavoriamo, scritto per tutti. Firmato da chi lo ha scritto.",
        soon: "Presto.",
    },

    postCta: {
        title: "Vuoi sapere come sta il tuo store?",
        text: "Mandaci l'indirizzo. Ti rispondiamo con un'analisi in 48 ore, senza call.",
        cta: "Analisi gratuita",
    },
};
